module.exports = __webpack_public_path__ + "img/minus (copy).90409b9c.svg";